import { render, staticRenderFns } from "./UserPassword.vue?vue&type=template&id=d161ff2c&scoped=true&"
import script from "./UserPassword.vue?vue&type=script&lang=js&"
export * from "./UserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d161ff2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d161ff2c')) {
      api.createRecord('d161ff2c', component.options)
    } else {
      api.reload('d161ff2c', component.options)
    }
    module.hot.accept("./UserPassword.vue?vue&type=template&id=d161ff2c&scoped=true&", function () {
      api.rerender('d161ff2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/UserPassword.vue"
export default component.exports